module.exports = __webpack_public_path__ + "img/collection-engagementRingsLabGrownDiamonds.a55fd10.webp";